import { USER_PERMISSION } from '~/consts/user';
import { getStore } from '~/mobx/AppStore';

const getIsStandAdmin = () => {
    const { userStore } = getStore();
    return userStore.user?.permissions.includes(USER_PERMISSION.STAND_ADMIN);
};

export default getIsStandAdmin;
